module.exports = __webpack_public_path__ + "assets/img/walletBg1.6364633f.png";